import { ref, useId } from "vue";

// @see https://portal-vue.linusb.org/api/portal-target.html#events-api
export type PortalChangeEvent = {
  hasContent: boolean;
  sources: string[];
};

export function usePortalContent<PortalPrefix extends string>(
  portalName: PortalPrefix
) {
  const hasPortalContent = ref(false);

  // this is provided by PortalTarget
  const handlePortalChange = (event: PortalChangeEvent) => {
    const hasNewContent = event?.hasContent ?? false;

    if (hasPortalContent.value !== hasNewContent) {
      hasPortalContent.value = hasNewContent;
    }
  };

  return {
    handlePortalChange,
    hasPortalContent,
    portalName: `${portalName}-${useId()}` as `${PortalPrefix}-${string}`,
  };
}
